// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ContactUsForm from "@mcmc/App/Components/ContactUsForm/ContactUsForm";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    contactUsPardotUrl: (getSettingsCollection(state).customSettings as any)?.contactUsPagePardotUrl,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const ContactUsPardotForm = ({ contactUsPardotUrl }: Props) => {
    return <ContactUsForm formUrl={contactUsPardotUrl} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ContactUsPardotForm),
    definition: {
        group: "Contact Us",
        icon: "FormField",
    },
};

export default widgetModule;
